export const FILE_FORMATS = {
  'text/rtf': { icon: { lib: 'far', name: 'file-alt' }, format_name: 'rtf' },
  'application/pdf': {
    icon: { lib: 'far', name: 'file-pdf' },
    format_name: 'pdf',
  },
  'application/zip': {
    icon: { lib: 'far', name: 'file-archive' },
    format_name: 'zip',
  },
  'application/x-zip-compressed': {
    icon: { lib: 'far', name: 'file-archive' },
    format_name: 'zip',
  },
  'application/gzip': {
    icon: { lib: 'far', name: 'file-archive' },
    format_name: 'gzip',
  },
  'application/vnd.rar': {
    icon: { lib: 'far', name: 'file-archive' },
    format_name: 'rar',
  },
  'application/x-tar': {
    icon: { lib: 'far', name: 'file-archive' },
    format_name: 'tar',
  },
  'application/json': {
    icon: { lib: 'far', name: 'file-code' },
    format_name: 'json',
  },
  'text/javascript': {
    icon: { lib: 'far', name: 'file-code' },
    format_name: 'js',
  },
  'text/html': { icon: { lib: 'far', name: 'file-code' }, format_name: 'html' },
  'image/jpg': {
    icon: { lib: 'far', name: 'file-image' },
    format_name: 'jpg',
  },
  'image/jpeg': {
    icon: { lib: 'far', name: 'file-image' },
    format_name: 'jpeg',
  },
  'image/png': {
    icon: { lib: 'far', name: 'file-image' },
    format_name: 'png',
  },
  'image/svg': {
    icon: { lib: 'far', name: 'file-image' },
    format_name: 'svg',
  },
  'application/msword': {
    icon: { lib: 'far', name: 'file-word' },
    format_name: 'Word',
  },
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': {
    icon: { lib: 'far', name: 'file-word' },
    format_name: 'Word',
  },
  'application/vnd.ms-excel': {
    icon: { lib: 'far', name: 'file-excel' },
    format_name: 'Excel',
  },
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': {
    icon: { lib: 'far', name: 'file-excel' },
    format_name: 'Excel',
  },
  'application/vnd.ms-powerpoint': {
    icon: { lib: 'far', name: 'file-ppt' },
    format_name: 'PowerPoint',
  },
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': {
    icon: { lib: 'far', name: 'file-ppt' },
    format_name: 'PowerPoint',
  },
  'text/xml': {
    icon: { lib: 'far', name: 'file' },
    format_name: 'XML',
  },
  'application/xml': {
    icon: { lib: 'far', name: 'file' },
    format_name: 'XML',
  },
  'text/plain': {
    icon: { lib: 'far', name: 'file-alt' },
    format_name: 'TXT',
  },
};

export const getFileViewFormat = (file) => {
  const typeOfContent = file['mime_type'];

  const viewFormat = {
    icon: null,
    label: null,
  };
  if (FILE_FORMATS[typeOfContent]) {
    viewFormat.icon = FILE_FORMATS[typeOfContent]?.icon;
    viewFormat.label = FILE_FORMATS[typeOfContent].format_name;
  }
  return viewFormat;
};
